import React, { memo, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { BannerWrapper } from './ad.style';
import useAds from '@gameday/utils/hooks/useAds';
import MessageService from 'message-service/message-service';

const SingleAd = ({
    type,
    ads,
    className
}) => {
    const AdsInfo = useAds();
    const { drawSingleAd, doubleclickGetGptadslots } = AdsInfo?.adEngine?.doubleclick || {};
    const thisAd = ads?.[0];

    const drawOneSingleAd = useCallback(() => {
        const adUnit = thisAd;
        if (adUnit) {
            const { container } = adUnit;
            const dom = document.querySelector('#' + container);
            const shouldDrawAd = adUnit?.init;
            const existedAd = doubleclickGetGptadslots && doubleclickGetGptadslots()?.[container];

            if (shouldDrawAd && dom) {
                setTimeout(function () {
                    if (!existedAd && drawSingleAd) {
                        drawSingleAd(adUnit);
                    }
                }, 100);
            }
        }
    }, [thisAd, drawSingleAd, doubleclickGetGptadslots]);

    useEffect(() => {
        if (thisAd && drawSingleAd) {
            drawSingleAd(thisAd);
        }

        MessageService.on('AD_THRESHOLD_CHANGE', drawOneSingleAd);
        return () => {
            MessageService.off('AD_THRESHOLD_CHANGE', drawOneSingleAd);
        };
    }, [thisAd]);

    if (!thisAd) {
        return null;
    }

    return (
        <BannerWrapper id={`gameday-index-component__${type}`} className={className}>
            <div className={'ad-responsive-slot'}>
                {ads.map((data, index) => {
                    const {
                        container = '',
                        sizes = [],
                        thresholds = [],
                        targeting: { pos } = {}
                    } = data;

                    return (
                        <div
                            id={container}
                            key={`${type}-${index}`}
                            className="ad-responsive-size"
                            data-thresholds={thresholds}
                            data-sizes={sizes}
                            data-targeting={`{ pos: ${pos}, content: "gameday"}`}
                        />
                    );
                })}
            </div>
        </BannerWrapper>
    );
};

SingleAd.propTypes = {
    type: PropTypes.string,
    ads: PropTypes.array,
    className: PropTypes.string
};

export default memo(SingleAd);
